import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bradwestfall/Desktop/ReactTraining/Projects/monorepo/reacttraining.com/src/page-templates/BlogArticlePage.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Today, after a year of working apart, I'm excited to welcome Ryan Florence back to React Training--the company we started together almost 4 years ago. We tried working solo last year, and we both learned a lot and taught a LOT of React workshops, Ryan as part of reach.tech and me as part of React Training. But, it just wasn't as much fun as teaching together. So we’re teaming up again this year and we're excited to bring some new code and material to you!`}</p>
    <p>{`This is what you can expect from us this year:`}</p>
    <ul>
      <li parentName="ul">{`An all-new, 10 city, `}<a parentName="li" {...{
          "href": "/workshops"
        }}>{`React Hooks Workshop Tour`}</a>{`.`}</li>
      <li parentName="ul">{`Continued development on our open source projects, including `}<a parentName="li" {...{
          "href": "https://github.com/ReactTraining/react-router"
        }}>{`React Router`}</a>{`, `}<a parentName="li" {...{
          "href": "https://github.com/reach/router"
        }}>{`Reach Router`}</a>{`, and `}<a parentName="li" {...{
          "href": "https://github.com/reach/reach-ui"
        }}>{`Reach UI`}</a>{` (we’ll get a roadmap about the routers published soon, but you’ll be fine with either one!)`}</li>
      <li parentName="ul">{`Online courses from React Training (existing `}<a parentName="li" {...{
          "href": "https://courses.reach.tech/"
        }}>{`Reach subscribers`}</a>{` will automatically migrate over)`}</li>
      <li parentName="ul">{`Regular free content on the `}<a parentName="li" {...{
          "href": "https://reacttraining.com/blog"
        }}>{`React Training blog`}</a>{` and `}<a parentName="li" {...{
          "href": "https://newsletter.reacttraining.com/"
        }}>{`newsletter`}</a></li>
    </ul>
    <p>{`We're also taking the business a little more seriously this year and are excited to work with a few of the best people we know to help us grow. This year we are welcoming `}<a parentName="p" {...{
        "href": "https://twitter.com/bradwestfall"
      }}>{`Brad Westfall`}</a>{`, `}<a parentName="p" {...{
        "href": "https://twitter.com/daniellovell"
      }}>{`Daniel Lovell`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://twitter.com/stefyyleon"
      }}>{`Estefania Leon`}</a>{` to the team. Brad is going to help us teach, and Daniel and Estefania are going to be running logistics and customer support.`}</p>
    <p>{`When Ryan and I started this business, we weren't sure how long React would last. Some people said it was hype, but we knew it was something more. Now, after almost 4 years in business and having taught React to literally thousands of developers at workshops, conferences, and meetups all over the world, we're more optimistic than ever that React is here to stay. The React team is focused on solving the hard problems, and the community is vibrant and creative. We're excited to be a part of it and are forever grateful for your support. We hope to see you on tour!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      